import { useTranslation } from 'react-i18next'

import { Badge, IconRegistry, BadgeVariant } from '@percent/lemonade'
import { getProperCasedStatus } from '@percent/partner-dashboard/common/components'
import { LocaleKey } from '@percent/partner-dashboard/i18n/config'
import { DonationListStatusFilterEnum } from '@percent/partner-dashboard/services/donation/donationService.types'

type ActiveDonationStatus = Exclude<DonationListStatusFilterEnum, DonationListStatusFilterEnum.Cancelled>

const donationStatusMap: Record<
  ActiveDonationStatus,
  {
    status: BadgeVariant
    icon: keyof typeof IconRegistry
    text: string
  }
> = {
  [DonationListStatusFilterEnum.Active]: {
    status: 'warning',
    icon: 'info',
    text: 'status.awaitingFunds'
  },
  [DonationListStatusFilterEnum.RequestedPayment]: {
    status: 'warning',
    icon: 'info',
    text: 'status.awaitingFunds'
  },
  [DonationListStatusFilterEnum.ReceivedPayment]: {
    status: 'default',
    icon: 'payout',
    text: 'status.readyToPayout'
  },
  [DonationListStatusFilterEnum.Settled]: {
    status: 'default',
    icon: 'payout',
    text: 'status.readyToPayout'
  },
  [DonationListStatusFilterEnum.Disbursed]: {
    status: 'positive',
    icon: 'approve',
    text: 'status.paid'
  },
  [DonationListStatusFilterEnum.CheckSent]: {
    status: 'positive',
    icon: 'claims',
    text: 'status.checkSent'
  }
}

export function DonationStatusTableCell({ status }: { status: DonationListStatusFilterEnum }) {
  const { t: translate } = useTranslation()

  return (
    <Badge variant={donationStatusMap[status]?.status} icon={donationStatusMap[status]?.icon}>
      {getProperCasedStatus(translate(donationStatusMap[status]?.text as LocaleKey))}
    </Badge>
  )
}
